/* ==========================================================================
   Sprintbahn-Planer — Konfigurator-Logik
   --------------------------------------------------------------------------
   Geladen von: sections/ceq-sprintbahn-planer.liquid (defer).
   Jeder Konfigurator-Block bringt seine Konfiguration als JSON mit
   (script[type="application/json"] im Block). Preise, Farben und Regeln
   stehen dort — dieses File enthaelt KEINE Preise.

   Preisformel (Quelle: crossequip-verkauf/wiki/turf-bestellung-abwicklung.md):
     Ware     = EUR/m² x m²  + Logo + optionale Elemente
     Kosten   = Ware x fx + Transport      <- Transport ist CHF, nicht EUR
     Verkauf  = Kosten x Marge
     pro lfm  = aufgerundet auf ganze CHF        <- so steht es in der Offerte
     Total    = pro lfm x Laufmeter              <- Anzeige, nicht Verkauf roh

   Der Faktor "fx" heisst im Runbook "EUR->CHF", ist real aber ein Zuschlag
   mit Kurspuffer (der Kurs liegt unter 1). Nicht "korrigieren".
   ========================================================================== */

(function () {
  'use strict';

  var CHF = function (n) {
    return n.toLocaleString('de-CH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  /* Der Total ist Laufmeterpreis x Laenge und damit bei halben Metern auf
     50 Rappen genau. Nicht auf ganze Franken runden — sonst stimmt die
     Multiplikation nicht mehr, die der Kunde selbst nachrechnet. */
  var CHF_exact = function (n) {
    var whole = Math.abs(n % 1) < 0.005;
    return n.toLocaleString('de-CH', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  };

  var num = function (v, fallback) {
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : fallback;
  };

  /* Zwei Dezimalen, seit die Laenge frei eingebbar ist: gefertigt wird jedes
     Mass, 13,75 m muss also auch als 13,75 m dastehen und nicht als 13,8. */
  var fmtLen = function (m) {
    return m.toLocaleString('de-CH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  /* Zentimetergenau. Ohne das Runden schleppt jede Rechnung mit 0.1er-Schritten
     die Gleitkomma-Reste mit (0.1 + 0.2 = 0.30000000000000004). */
  var roundCm = function (v) {
    return Math.round(v * 100) / 100;
  };

  /* Abstand der Markierungen in Metern. Echt sind 0,5 m; reicht der Platz
     dafuer nicht, wird stufenweise ausgeduennt, damit die Striche nicht zu
     einer Flaeche verschmelzen. 7 px ist der Punkt, ab dem drei Pixel Strich
     und die Luecke dazwischen noch als Raster lesbar sind. */
  var TICK_STEPS = [0.5, 1, 2, 5, 10];
  var TICK_MIN_PX = 7;

  /* Zahlen brauchen mehr Luft als Striche. Beschriftet wird jeder Meter —
     erst wenn dafuer physisch kein Platz ist, wird ausgeduennt. */
  var NUM_STEPS = [1, 2, 5, 10];
  var NUM_MIN_PX = 13;

  function pickStep(steps, minPx, lengthM, widthPx) {
    var w = widthPx || 1200;
    for (var i = 0; i < steps.length; i++) {
      if ((steps[i] / lengthM) * w >= minPx) return steps[i];
    }
    return steps[steps.length - 1];
  }

  function tickStep(lengthM, widthPx) {
    return pickStep(TICK_STEPS, TICK_MIN_PX, lengthM, widthPx);
  }

  function numStep(lengthM, widthPx) {
    return pickStep(NUM_STEPS, NUM_MIN_PX, lengthM, widthPx);
  }

  function Configurator(root) {
    this.root = root;
    var raw = root.querySelector('[data-sbp-config]');
    if (!raw) return;

    try {
      this.cfg = JSON.parse(raw.textContent);
    } catch (e) {
      return;
    }

    this.state = {
      length: this.cfg.defaultLength,
      width: this.cfg.defaultWidth,
      /* Startet leer, nicht auf 3: das Sonderbreiten-Feld steht jetzt immer
         sichtbar in der Option und soll keinen Wert vortaeuschen, den niemand
         eingegeben hat. `null` heisst „noch nichts Gueltiges". */
      customWidth: null,
      colorId: this.cfg.colors.length ? this.cfg.colors[0].id : null,
      markingId: this.cfg.markingColors.length ? this.cfg.markingColors[0].id : null,
      logo: false,
      endText: false,
      eco: false,
      count: 1,
      elements: {},
      elementPos: {}
    };

    var st0 = this.state;
    (this.cfg.elements || []).forEach(function (e) {
      st0.elementPos[e.id] = e.defaultPos;
    });

    /* Uebergabe aus dem Massfinder: `?l=`, `?wm=` und `?n=` belegen Laenge,
       Breite und Stueckzahl vor (n = 2, wenn der Massfinder zwei Bahnen a 2 m
       statt einer 4-m-Rolle empfiehlt). Alles Weitere waehlt man ohnehin hier.
       Ungueltige oder fehlende Werte aendern nichts, der Planer startet dann
       wie immer. */
    if (typeof URLSearchParams === 'function' && window.location.search) {
      var q = new URLSearchParams(window.location.search);
      var ql = parseFloat(String(q.get('l')).replace(',', '.'));
      if (isFinite(ql) && ql >= this.cfg.minLength && ql <= this.cfg.maxLength) {
        this.state.length = roundCm(ql);
      }
      var qw = q.get('wm');
      if (qw === '2' || qw === '4') {
        this.state.width = qw;
      }
      var qn = parseInt(q.get('n'), 10);
      if (qn >= 1 && qn <= 20) {
        this.state.count = qn;
      }
    }

    this.el = {
      lenInput: root.querySelector('[data-sbp="len-input"]'),
      lenNote: root.querySelector('[data-sbp="len-note"]'),
      widths: root.querySelectorAll('[data-sbp-width]'),
      customWidthInput: root.querySelector('[data-sbp="custom-width-input"]'),
      swatches: root.querySelectorAll('[data-sbp-color]'),
      colorName: root.querySelector('[data-sbp="color-name"]'),
      swatchNote: root.querySelector('[data-sbp="swatch-note"]'),
      markings: root.querySelectorAll('[data-sbp-marking]'),
      markingName: root.querySelector('[data-sbp="marking-name"]'),
      logo: root.querySelector('[data-sbp="logo"]'),
      eco: root.querySelector('[data-sbp="eco"]'),
      ecoNote: root.querySelector('[data-sbp="eco-note"]'),
      endText: root.querySelector('[data-sbp="end-text"]'),
      elements: root.querySelectorAll('[data-sbp-element]'),
      elementPosRows: root.querySelectorAll('[data-sbp-element-pos]'),
      elementPosInputs: root.querySelectorAll('[data-sbp-element-pos-input]'),
      elementOverflow: root.querySelector('[data-sbp="element-overflow"]'),
      countNum: root.querySelector('[data-sbp="count-num"]'),
      countMinus: root.querySelector('[data-sbp="count-minus"]'),
      countPlus: root.querySelector('[data-sbp="count-plus"]'),
      track: root.querySelector('[data-sbp="track"]'),
      dims: root.querySelector('[data-sbp="dims"]'),
      previewNote: root.querySelector('[data-sbp="preview-note"]'),
      total: root.querySelector('[data-sbp="total"]'),
      preset: root.querySelector('[data-sbp="preset"]'),
      cta: root.querySelector('[data-sbp="cta"]'),
      calc: root.querySelector('[data-sbp="calc"]')
    };

    this.bind();
    this.render();
  }

  Configurator.prototype.bind = function () {
    var self = this;
    var cfg = this.cfg;

    if (this.el.lenInput) {
      /* Waehrend des Tippens wird gerechnet, aber NICHT ins Feld
         zurueckgeschrieben: sonst kann man "13.7" nie zu Ende tippen — nach
         der "1" klemmt setLength auf das Minimum, ueberschreibt das Feld und
         der Cursor springt ans Ende. Unplausible Zwischenstaende (leer, "0",
         "130") laufen ins Leere statt die Bahn zu verstellen. */
      this.el.lenInput.addEventListener('input', function () {
        var v = num(this.value, NaN);
        /* Ueber dem Maximum WIRD zurueckgeschrieben — sonst stand im Feld
           "80", waehrend der Preis stumm bei der letzten gueltigen Laenge
           blieb: eine 80-m-Bahn zum 12-m-Preis, ohne jede Rueckmeldung
           (gemeldet Simon, 01.09.2026). Der Cursor-Sprung, den der Kommentar
           oben fuers Minimum beschreibt, ist hier kein Thema — eine Zahl ueber
           50 ist nie der Zwischenstand einer gueltigen Eingabe. */
        if (isFinite(v) && v > cfg.maxLength) {
          this.value = String(cfg.maxLength);
          self.lenWarn(true);
          self.setLength(cfg.maxLength);
          return;
        }
        if (!isFinite(v) || v < cfg.minLength || v > cfg.maxLength) return;
        self.lenWarn(false);
        self.state.length = roundCm(v);
        self.render({ keepLenInput: true });
      });

      /* Beim Verlassen des Feldes normalisieren — hier wird geklemmt und der
         aufgeraeumte Wert zurueckgeschrieben. */
      this.el.lenInput.addEventListener('change', function () {
        self.lenWarn(false);
        self.setLength(num(this.value, cfg.defaultLength));
      });
    }

    /* Klick auf 2 m / 4 m leert das Sonderbreiten-Feld: es steht jetzt immer
       sichtbar daneben, und ein stehengebliebener Wert waere eine Breite, die
       nicht mehr gilt. Die Sonderbreite selbst reagiert nicht auf Klick — dort
       waehlt man ueber das Feld. */
    Array.prototype.forEach.call(this.el.widths, function (btn) {
      if (btn.getAttribute('data-sbp-width') === 'other') return;
      btn.addEventListener('click', function () {
        self.state.width = btn.getAttribute('data-sbp-width');
        self.state.customWidth = null;
        if (self.el.customWidthInput) self.el.customWidthInput.value = '';
        self.render();
      });
    });

    if (this.el.customWidthInput) {
      /* Tippen ins Feld waehlt die Sonderbreite — ein separater Klick auf die
         Option davor ist nicht noetig und waere auch nicht zu erraten.
         Unplausible Zwischenstaende (leer, "0", "12") schalten nichts um. */
      this.el.customWidthInput.addEventListener('input', function () {
        var v = num(this.value, NaN);
        if (!isFinite(v) || v < 1 || v > 4) return;
        self.state.customWidth = roundCm(v);
        self.state.width = 'other';
        self.render({ keepCustomWidth: true });
      });

      /* Beim Verlassen aufraeumen: ein leeres oder unmoegliches Feld faellt auf
         die Standardbreite zurueck, statt eine Breite offenzulassen, mit der
         niemand rechnen kann. */
      this.el.customWidthInput.addEventListener('change', function () {
        var v = num(this.value, NaN);
        if (!isFinite(v) || v < 1 || v > 4) {
          this.value = '';
          self.state.customWidth = null;
          if (self.state.width === 'other') self.state.width = cfg.defaultWidth;
        } else {
          self.state.customWidth = roundCm(v);
          self.state.width = 'other';
          this.value = String(self.state.customWidth);
        }
        self.render({ keepCustomWidth: true });
      });
    }

    Array.prototype.forEach.call(this.el.swatches, function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self.state.colorId = btn.getAttribute('data-sbp-color');
        self.render();
      });
    });

    Array.prototype.forEach.call(this.el.markings, function (btn) {
      btn.addEventListener('click', function () {
        self.state.markingId = btn.getAttribute('data-sbp-marking');
        self.render();
      });
    });

    if (this.el.logo) {
      this.el.logo.addEventListener('change', function () {
        self.state.logo = this.checked;
        self.render();
      });
    }

    if (this.el.endText) {
      this.el.endText.addEventListener('change', function () {
        self.state.endText = this.checked;
        self.render();
      });
    }

    if (this.el.eco) {
      this.el.eco.addEventListener('change', function () {
        self.state.eco = this.checked;
        self.render();
      });
    }

    Array.prototype.forEach.call(this.el.elements, function (box) {
      box.addEventListener('change', function () {
        self.state.elements[box.getAttribute('data-sbp-element')] = box.checked;
        self.render();
      });
    });

    Array.prototype.forEach.call(this.el.elementPosInputs, function (input) {
      input.addEventListener('input', function () {
        var id = input.getAttribute('data-sbp-element-pos-input');
        self.state.elementPos[id] = Math.max(0, num(this.value, 0));
        self.render();
      });
    });

    if (this.el.countMinus) {
      this.el.countMinus.addEventListener('click', function () {
        self.state.count = Math.max(1, self.state.count - 1);
        self.render();
      });
    }

    if (this.el.countPlus) {
      this.el.countPlus.addEventListener('click', function () {
        self.state.count = Math.min(20, self.state.count + 1);
        self.render();
      });
    }

    if (this.el.preset) {
      this.el.preset.addEventListener('click', function () {
        self.state.length = cfg.preset.length;
        self.state.width = cfg.preset.width;
        if (cfg.preset.colorId) self.state.colorId = cfg.preset.colorId;
        self.render();
        self.track('turf_preset_click');
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Ein Listener fuer alle Bedienelemente statt 15 einzelne: meldet die
       ERSTE Interaktion in diesem Konfigurator und haengt sich danach aus.
       Capture-Phase, damit er auch feuert, wenn ein Handler stoppt. */
    var startFired = false;
    var onFirstTouch = function (event) {
      if (startFired) return;
      /* Der Anfrage-Button ist keine Konfiguration — der hat sein eigenes
         Event und soll `turf_config_start` nicht vorwegnehmen. */
      if (self.el.cta && event.target.closest && event.target.closest('[data-sbp="cta"]')) return;
      startFired = true;
      self.track('turf_config_start');
      ['input', 'change', 'click'].forEach(function (type) {
        self.root.removeEventListener(type, onFirstTouch, true);
      });
    };
    ['input', 'change', 'click'].forEach(function (type) {
      self.root.addEventListener(type, onFirstTouch, true);
    });

    if (this.el.cta) {
      this.el.cta.addEventListener('click', function () {
        self.track('turf_inquiry_click');
      });
    }

  };

  /* GA4-Parameter aus dem aktuellen Stand. Bewusst sprechende Namen statt der
     Kuerzel aus query() — die Query ist fuer die Zielseite, das hier fuer die
     Auswertung. `value` + `currency` fuellen die Umsatzspalte, damit eine
     Anfrage nicht nur zaehlbar, sondern auch gewichtbar ist. */
  Configurator.prototype.trackParams = function (extra) {
    var c = this.calc();
    var self = this;
    var chosen = (this.cfg.elements || []).filter(function (e) {
      return self.state.elements[e.id];
    });

    var p = {
      turf_type: this.cfg.type,
      type_code: this.cfg.typeCode,
      length_m: c.length,
      width_m: c.width,
      track_color: this.state.colorId || '',
      has_logo: this.state.logo ? 1 : 0,
      element_count: chosen.length,
      quantity: c.count,
      value: c.total,
      currency: 'CHF'
    };
    if (this.cfg.hasMarking) p.marking_color = this.state.markingId || '';
    if (this.cfg.hasEndText) p.has_end_text = this.state.endText ? 1 : 0;

    return Object.assign(p, extra || {});
  };

  Configurator.prototype.track = function (name, extra) {
    if (typeof window.ceqTurfTrack !== 'function') return;
    /* Beim Start steht noch nichts Konfiguriertes — nur die Ausfuehrung. */
    if (name === 'turf_config_start') {
      window.ceqTurfTrack(name, { turf_type: this.cfg.type, type_code: this.cfg.typeCode });
      return;
    }
    window.ceqTurfTrack(name, this.trackParams(extra));
  };

  /* Hinweiszeile unter dem Laengenfeld: normal die Bedienhilfe, bei
     ueberschrittenem Maximum die Grenze. Faellt still aus, wenn das Markup
     die Zeile nicht traegt. */
  Configurator.prototype.lenWarn = function (on) {
    var el = this.el.lenNote;
    if (!el) return;
    var i18n = this.cfg.i18n || {};
    var txt = on ? i18n.lengthMax : i18n.lengthHint;
    if (txt) el.textContent = txt;
    el.classList.toggle('ceq-sbp-len__warn', !!on);
  };

  /* Frei bis auf den Zentimeter. Bis zum 13.08.2026 rastete jede Eingabe auf
     halbe Meter ein — gefertigt wird aber jedes Mass, und wer 13,7 m Platz hat,
     soll 13,7 m eingeben koennen. */
  Configurator.prototype.setLength = function (v) {
    var cfg = this.cfg;
    var next = roundCm(num(v, cfg.defaultLength));
    this.state.length = Math.min(cfg.maxLength, Math.max(cfg.minLength, next));
    this.render();
  };

  /* Effektive Breite in Metern. Bei Sonderbreite kommt sie aus dem Zahlenfeld;
     solange dort nichts Gueltiges steht, gilt die Standardbreite — sonst
     rechnete der Konfigurator mit `null` und zeigte NaN. */
  Configurator.prototype.widthM = function () {
    if (this.state.width === 'other') {
      return this.state.customWidth || num(this.cfg.defaultWidth, 2);
    }
    return num(this.state.width, 2);
  };

  /* Mit Start-/Ziel-Schriftzug gilt die zweite Preisreihe der Liste, nicht ein
     Aufpreis obendrauf — es ist derselbe m² zu einem hoeheren Satz. */
  Configurator.prototype.rate = function () {
    var r = this.cfg.rates;
    if (this.state.endText && this.cfg.hasEndText && this.cfg.ratesText) {
      r = this.cfg.ratesText;
    }
    if (this.state.width === 'other') return r.other;
    if (this.state.width === '4') return r.w4;
    return r.w2;
  };

  Configurator.prototype.color = function () {
    var id = this.state.colorId;
    for (var i = 0; i < this.cfg.colors.length; i++) {
      if (this.cfg.colors[i].id === id) return this.cfg.colors[i];
    }
    return this.cfg.colors[0];
  };

  Configurator.prototype.marking = function () {
    var list = this.cfg.markingColors;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === this.state.markingId) return list[i];
    }
    return list[0] || null;
  };

  /* Stueckzahl multipliziert Ware, Logo und Elemente — jede Bahn wird einzeln
     gefertigt. Die Speditionspauschale faellt nur EINMAL an: es ist eine
     Lieferung, egal ob eine oder vier Bahnen darauf liegen. */
  Configurator.prototype.calc = function () {
    var cfg = this.cfg;
    var len = this.state.length;
    var w = this.widthM();
    var count = this.state.count || 1;
    var sqmOne = w * len;
    var sqm = sqmOne * count;
    var rate = this.rate();

    var perTrack = rate * sqmOne;
    if (this.state.logo && cfg.logoEur) perTrack += cfg.logoEur;

    var self = this;
    var elementsOne = 0;
    cfg.elements.forEach(function (e) {
      if (self.state.elements[e.id]) elementsOne += e.price;
    });
    perTrack += elementsOne;

    /* Ware ist EUR und wird umgerechnet, der Transport ist bereits CHF und
       kommt danach dazu. Beides zusammen ist die Kostenbasis fuer die Marge.
       Spedition faellt einmal je Lieferung an, nicht je Bahn. */
    var goods = perTrack * count;
    var cost = goods * cfg.fx + cfg.shippingChf;
    var sell = cost * cfg.margin;

    /* Offerten-Rundung: auf den ganzen Laufmeterpreis, aufwaerts. Bezugsgroesse
       sind alle Laufmeter zusammen, nicht die einzelne Bahn. */
    var lm = len * count;
    var perLm = Math.ceil(sell / lm);
    var total = perLm * lm;

    /* Die Unterlage ist eigene Lagerware in Franken und laeuft deshalb weder
       durch den Kursfaktor noch durch die Marge -- sie kommt erst nach der
       Laufmeter-Rundung dazu, sonst waere sie um rund ein Drittel zu teuer.
       Eine Platte misst 1 x 1 m, die Menge ist damit die aufgerundete
       Bahnflaeche; angebrochene Quadratmeter zahlt niemand halb. */
    var ecoPlatten = cfg.ecoChf > 0 ? Math.ceil(sqm) : 0;
    var ecoChf = this.state.eco ? ecoPlatten * cfg.ecoChf : 0;
    total += ecoChf;

    return {
      ecoPlatten: ecoPlatten,
      ecoChf: ecoChf,
      sqm: sqm,
      sqmOne: sqmOne,
      width: w,
      length: len,
      count: count,
      rate: rate,
      goods: goods,
      elementsTotal: elementsOne * count,
      perLm: perLm,
      total: total
    };
  };

  /* `opts.keepLenInput` / `opts.keepQtyInput` halten das Feld unangetastet, in
     dem gerade getippt wird — siehe Kommentar bei den Eingabe-Handlern. */
  Configurator.prototype.render = function (opts) {
    var cfg = this.cfg;
    var st = this.state;
    var self = this;
    var wM = this.widthM();

    /* --- Farbregel: oberhalb 2 m Breite fallen sechs Farben weg. --------- */
    var limited = wM > 2;
    var current = this.color();
    if (limited && current && current.maxWidth < wM) {
      for (var i = 0; i < cfg.colors.length; i++) {
        if (cfg.colors[i].maxWidth >= wM) {
          st.colorId = cfg.colors[i].id;
          break;
        }
      }
    }
    var color = this.color();

    Array.prototype.forEach.call(this.el.swatches, function (btn) {
      var max = num(btn.getAttribute('data-sbp-max'), 4);
      var allowed = max >= wM;
      btn.disabled = !allowed;
      btn.setAttribute('aria-pressed', btn.getAttribute('data-sbp-color') === st.colorId ? 'true' : 'false');
    });

    if (this.el.swatchNote) {
      /* Ausfuehrungen mit `black_only` liefern genau eine Farbe — dort ist
         sowohl "Zwoelf Farben" als auch der Breiten-Hinweis falsch. */
      this.el.swatchNote.textContent = cfg.colors.length === 1
        ? (cfg.i18n.colorsSingle || cfg.i18n.colorsAll)
        : (limited ? cfg.i18n.colorsLimited : cfg.i18n.colorsAll);
    }
    if (this.el.colorName) this.el.colorName.textContent = color ? color.name : '';

    var marking = this.marking();
    Array.prototype.forEach.call(this.el.markings, function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-sbp-marking') === st.markingId ? 'true' : 'false');
    });
    if (this.el.markingName) this.el.markingName.textContent = marking ? marking.name : '';

    /* --- Breite ---------------------------------------------------------- */
    Array.prototype.forEach.call(this.el.widths, function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-sbp-width') === st.width ? 'true' : 'false');
    });
    if (this.el.customWidthInput && !(opts && opts.keepCustomWidth)) {
      this.el.customWidthInput.value = st.customWidth ? String(st.customWidth) : '';
    }

    /* --- Laenge ---------------------------------------------------------- */
    /* `String()` statt `fmtLen()`: das Feld ist ein `type="number"`, und dort
       ist nur der Punkt als Dezimaltrenner gueltig. Ein Apostroph-Tausender
       waere es ebenfalls nicht — bei maximal 50 m kommt der zwar nie vor, aber
       `String()` kann beides gar nicht erst erzeugen. */
    if (this.el.lenInput && !(opts && opts.keepLenInput)) {
      this.el.lenInput.value = String(st.length);
    }

    /* Die Vorkonfiguration verhaelt sich wie ein Laengen-Chip: gewaehlt,
       solange die Bahn auf ihrer Laenge steht. */
    if (this.el.preset && cfg.preset) {
      this.el.preset.setAttribute('aria-pressed', st.length === cfg.preset.length ? 'true' : 'false');
    }

    /* --- Stueckzahl ------------------------------------------------------ */
    if (this.el.countNum) this.el.countNum.textContent = st.count;
    if (this.el.countMinus) this.el.countMinus.disabled = st.count <= 1;
    if (this.el.countPlus) this.el.countPlus.disabled = st.count >= 20;

    /* --- Optionale Elemente: Positionsfeld klappt mit der Checkbox auf ---- */
    Array.prototype.forEach.call(this.el.elementPosRows, function (row) {
      var id = row.getAttribute('data-sbp-element-pos');
      if (st.elements[id]) {
        row.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', '');
      }
    });

    /* --- Vorschau -------------------------------------------------------- */
    this.renderPreview(color, wM);

    /* --- Preis ----------------------------------------------------------- */
    var c = this.calc();
    if (this.el.total) this.el.total.textContent = CHF_exact(c.total);
    if (this.el.ecoNote) {
      this.el.ecoNote.textContent = this.state.eco
        ? ((cfg.i18n && cfg.i18n.ecoNote) || '')
            .replace('{{platten}}', String(c.ecoPlatten))
            .replace('{{chf}}', CHF_exact(c.ecoChf))
        : '';
    }
    if (this.el.cta && cfg.inquiryUrl) {
      this.el.cta.href = cfg.inquiryUrl + '?' + this.query();
    }
    /* Rechenblatt bekommt Gesamtflaeche und Total -- `#rechenblatt` ist die
       Block-ID des Werkzeugs auf der Kaufberatungsseite. */
    if (this.el.calc && cfg.calcUrl) {
      this.el.calc.href = cfg.calcUrl + '?sqm=' + c.sqm + '&tot=' + c.total + '#rechenblatt';
    }

    this.last = c;
  };

  Configurator.prototype.renderPreview = function (color, wM) {
    var markHex = this.cfg.hasMarking && this.marking() ? this.marking().hex : '#ffffff';
    var cfg = this.cfg;
    var st = this.state;
    var track = this.el.track;
    if (!track) return;

    /* Hoehe folgt der Breite, nicht dem echten Massstab: eine 50-m-Bahn
       waere sonst ein 2-Pixel-Streifen. Proportion statt Massstab. */
    track.style.height = Math.round(26 * wM + 8) + 'px';
    track.style.backgroundColor = color ? color.hex : '#000';
    track.innerHTML = '';

    if (wM >= 4) {
      var centre = document.createElement('div');
      centre.className = 'ceq-sbp-preview__centre';
      track.appendChild(centre);
    }

    /* Keine durchgehenden Endlinien — die Bahn traegt an den Enden nur die
       Randmarken und, wenn mitbestellt, den Schriftzug. */
    if (st.endText && cfg.hasEndText) {
      [['start', cfg.i18n.startLabel], ['finish', cfg.i18n.finishLabel]].forEach(function (pair) {
        var label = document.createElement('span');
        label.className = 'ceq-sbp-preview__end-label ceq-sbp-preview__end-label--' + pair[0];
        label.style.color = markHex;
        label.textContent = pair[1];
        track.appendChild(label);
      });
    }

    /* Hybrid: drei Laengslinien und je eine Quermarke pro Spur. Die Marken
       sitzen auf der Spurmitte, also auf einem und drei Vierteln der Hoehe. */
    if (cfg.hasLanes) {
      ['top', 'middle', 'bottom'].forEach(function (pos) {
        var lane = document.createElement('div');
        lane.className = 'ceq-sbp-preview__lane ceq-sbp-preview__lane--' + pos;
        lane.style.backgroundColor = markHex;
        track.appendChild(lane);
      });
      ['25%', '75%'].forEach(function (top) {
        ['left', 'right'].forEach(function (side) {
          var mark = document.createElement('div');
          mark.className = 'ceq-sbp-preview__lane-mark';
          mark.style[side] = '3%';
          mark.style.top = top;
          mark.style.backgroundColor = markHex;
          track.appendChild(mark);
        });
      });
    }

    /* Zwischenmarkierungen: alle 0,5 m ein kurzer Strich an beiden Raendern,
       jeder ganze Meter laenger. Wird die Bahn so lang, dass die Striche
       ineinanderlaufen, greift `tickStep()` und duennt aus — lieber ein
       ehrliches Raster als ein weisser Balken. */
    if (cfg.hasMarks) {
      var step = tickStep(st.length, track.clientWidth);
      for (var m = step; m < st.length - 0.001; m += step) {
        var left = (m / st.length) * 100;
        var full = Math.abs(m % 1) < 0.001;
        ['top', 'bottom'].forEach(function (side) {
          var tick = document.createElement('div');
          tick.className = 'ceq-sbp-preview__tick ceq-sbp-preview__tick--' + side +
            (full ? ' ceq-sbp-preview__tick--full' : '');
          tick.style.left = left + '%';
          tick.style.backgroundColor = markHex;
          track.appendChild(tick);
        });
      }
    }

    /* Meterzahlen auf der Bahn — jeder Meter, wie auf der echten Bahn. Eigene
       Regel, nicht am Strichraster haengend: Striche vertragen mehr Enge. */
    if (cfg.hasNums) {
      var lblStep = numStep(st.length, track.clientWidth);
      for (var n = lblStep; n < st.length - 0.001; n += lblStep) {
        var lbl = document.createElement('span');
        lbl.className = 'ceq-sbp-preview__num';
        lbl.style.left = ((n / st.length) * 100) + '%';
        lbl.style.color = markHex;
        lbl.textContent = fmtLen(n);
        track.appendChild(lbl);
      }
    }

    /* Optionale Elemente. Die Position laengs ist massstaeblich, die GROESSE
       nicht: quer folgt sie der Bahnbreite (ein 1,5-m-Kreis nimmt drei Viertel
       einer 2-m-Bahn ein), laengs ergibt sie sich aus der Form selbst. Sonst
       wuerde die Vorschau die Elemente genauso stauchen wie die Bahn — aus
       dem Kreis wurde ein flaches Oval, aus dem Quadrat ein Querrechteck.
       Lieber Form und Lage richtig als eine Groesse, die ohnehin niemand
       ablesen kann. */
    var self = this;
    var trackH = 26 * wM + 8;
    var overflow = false;
    (cfg.elements || []).forEach(function (e) {
      if (!st.elements[e.id]) return;

      var pos = st.elementPos[e.id];
      if (pos === undefined || pos === null) pos = e.defaultPos || 0;

      /* Was hinter dem Bahnende laege, wird nicht gezeichnet — die Vorschau
         soll zeigen, was passt, statt ueber den Rand hinauszuragen. Gerechnet
         wird es trotzdem, darum der Hinweis unter der Auswahl: sonst wirkt die
         Vorschau kaputt statt die Position zu weit hinten. */
      if (pos + e.lengthM > st.length + 0.001) {
        overflow = true;
        return;
      }

      var hPx = (e.widthM / wM) * trackH;
      var box = document.createElement('div');
      box.className = 'ceq-sbp-preview__element';
      box.style.left = ((pos / st.length) * 100) + '%';
      box.style.height = hPx + 'px';
      box.style.width = (hPx * (e.lengthM / e.widthM)) + 'px';
      box.style.color = markHex;
      box.title = e.label;

      /* Die Form liegt als <template> im Markup — siehe Kommentar dort. */
      var shape = self.root.querySelector('[data-sbp-shape="' + e.id + '"]');
      if (shape && shape.content) box.appendChild(shape.content.cloneNode(true));

      track.appendChild(box);
    });

    if (this.el.elementOverflow) {
      if (overflow) {
        this.el.elementOverflow.removeAttribute('hidden');
      } else {
        this.el.elementOverflow.setAttribute('hidden', '');
      }
    }

    if (this.el.dims) {
      this.el.dims.textContent = fmtLen(st.length) + ' m × ' + fmtLen(wM) + ' m';
    }
    if (this.el.previewNote) {
      var c = this.calc();
      this.el.previewNote.textContent =
        (color ? color.name : '') + ' · ' + cfg.typeLabel + ' · ' +
        c.sqm.toLocaleString('de-CH', { maximumFractionDigits: 1 }) + ' m²';
    }
  };

  /* Die Konfiguration reist als Query-Parameter zur Anfrage-Seite.
     Bewusst Maschinen-Werte (Typ-Schluessel, Farb-ID) statt fertiger Labels:
     die Zielseite kennt ihre eigene Sprache und beschriftet selbst. So zeigt
     die EN-Seite EN-Labels, auch wenn der Link von der DE-Seite kam.
     Personendaten sind hier keine drin — die tippt der Kunde erst dort. */
  Configurator.prototype.query = function () {
    var cfg = this.cfg;
    var c = this.calc();
    var self = this;

    var chosen = cfg.elements
      .filter(function (e) { return self.state.elements[e.id]; })
      .map(function (e) { return e.id; });

    var p = new URLSearchParams();
    p.set('t', cfg.type);
    p.set('code', cfg.typeCode);
    p.set('l', String(c.length));
    p.set('w', String(c.width));
    p.set('wm', this.state.width);
    p.set('c', this.state.colorId || '');
    if (cfg.hasMarking) p.set('mc', this.state.markingId || '');
    p.set('logo', this.state.logo ? '1' : '0');
    if (this.state.eco) {
      p.set('eco', '1');
      p.set('ecoq', String(c.ecoPlatten));
      p.set('ecochf', String(c.ecoChf));
    }
    if (cfg.hasEndText) p.set('txt', this.state.endText ? '1' : '0');
    p.set('n', String(c.count));
    if (chosen.length) {
      p.set('el', chosen.join(','));
      /* Positionen in derselben Reihenfolge wie `el` — die Zielseite paart sie
         wieder zusammen. */
      p.set('elp', chosen.map(function (id) { return self.state.elementPos[id]; }).join(','));
    }
    p.set('plm', String(c.perLm));
    p.set('tot', String(c.total));
    return p.toString();
  };

  function init(scope) {
    var container = scope || document;

    Array.prototype.forEach.call(container.querySelectorAll('[data-sbp-configurator]'), function (el) {
      new Configurator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme-Editor: Section neu geladen -> Konfiguratoren neu verdrahten. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-sbp-configurator]')) {
      init(event.target);
    }
  });
})();
